export default {"src":"/_next/static/media/right-btn-arrow-green.a50f6888.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};